'use strict';

var isIosFirefox = require('./is-ios-firefox');

module.exports = function isMobileFirefox(ua) {
  ua = ua || global.navigator.userAgent;
  return isIosFirefox(ua) || /iPhone|iPod|iPad|Mobile|Tablet/i.test(ua) && /Firefox/i.test(ua);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@braintree/browser-detection/is-mobile-firefox.js
// module id = whay
// module chunks = 3